import { DepositDataDto } from "@api-types/deposit";
import {
	DepositFinalizeMultistep,
	DepositInitRequestData,
} from "@data-types/deposit";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { RequestContextType } from "@utils/api-config/RequestContext";
import { createApiRequestOptions } from "@utils/api-config/createApiRequestOptions";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";

export class DepositApiService {
	static baseUrl(context: ApiRequestContextData) {
		return `${WEBPACK_BASE_ADDRESS}${context?.agencyKey}/online-payments/deposit`;
	}

	static getRequestHeaders = (context: ApiRequestContextData) => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		appHeaders["Accept" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async initializeNewDepositProcess(
		data: DepositInitRequestData,
		options: ContextOptions = createApiRequestOptions(
			RequestContextType.Online
		)
	): Promise<DepositDataDto> {
		const context = getApiRequestContext(options);

		return await httpClient.post(
			`${this.baseUrl(context)}/initialize?translate=true`,
			JSON.stringify(data),
			this.getRequestHeaders(context)
		);
	}

	static async finalizeMultiStepDeposit(
		data: DepositFinalizeMultistep,
		options: ContextOptions = createApiRequestOptions(
			RequestContextType.Online
		)
	): Promise<DepositDataDto> {
		const context = getApiRequestContext(options);

		return await httpClient.post(
			`${this.baseUrl(context)}/finalize-multistep?translate=true`,
			JSON.stringify(data),
			this.getRequestHeaders(context)
		);
	}

	static async getAvailableMethods(
		options: ContextOptions = createApiRequestOptions(
			RequestContextType.Online
		)
	): Promise<DepositDataDto> {
		const context = getApiRequestContext(options);

		return await httpClient.get(
			`${this.baseUrl(context)}/available-methods`,
			this.getRequestHeaders(context)
		);
	}
}
